class DocumentElementClipController {
  constructor() {
    this.clipRefCount = 0;
  }
  clip() {
    document.documentElement.classList.add("is-clipped");
    this.clipRefCount += 1;
  }
  unclip() {
    this.clipRefCount = Math.max(0, this.clipRefCount - 1);
    if (this.clipRefCount === 0) {
      document.documentElement.classList.remove("is-clipped");
    }
  }
}
const documentElementClipController = new DocumentElementClipController();
export {
  documentElementClipController
};
//# sourceMappingURL=document-element-clip-controller.js.map
